import { TextField } from "@mui/material";
import React, { ReactElement, useEffect, useState } from "react";

import Button from "../components/button/button";
import Modal from "../components/modal/modal";
import useLocale from "../hooks/use-locale";

type Props = {
  open: boolean;
  defaultName: string;
  onClose(): void;
  onSubmit(name: string): Promise<void>;
};

export default function SaveAsTemplateModal(props: Props): ReactElement {
  const { open, defaultName, onClose, onSubmit } = props;
  const { getText } = useLocale();

  const [name, setName] = useState<string>(defaultName);

  useEffect(() => {
    if (open) {
      setName(defaultName);
    }
  }, [defaultName, open]);

  const nameTooShort = name.trim().length < 3;

  return (
    <Modal
      open={open}
      headline={getText("sections.imageComposer.saveAsTemplate.modal.title")}
      onClose={onClose}
      className="h-fit max-w-xl"
    >
      <>
        <TextField
          className="mb-[20px]"
          margin="dense"
          type="text"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          fullWidth
          focused
          variant="standard"
          error={nameTooShort}
          label={getText(
            "sections.imageComposer.saveAsTemplate.modal.nameLabel",
          )}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <div className="flex flex-row justify-between pt-6">
          <button type="button" onClick={onClose}>
            {getText("sections.imageComposer.saveAsTemplate.modal.cancel")}
          </button>
          <Button
            label={getText(
              "sections.imageComposer.saveAsTemplate.modal.confirm",
            )}
            onClick={() => onSubmit(name.trim())}
            disabled={nameTooShort}
          />
        </div>
      </>
    </Modal>
  );
}
